import { useMemo } from 'react';
import { isResourcePartiallyLoaded } from '~/_shared/types/fetchableResource/fetchableResource.helpers';
import { useRequiresCleanMap } from '~/_shared/utils/hooks/useRequiresCleanMap';
import { notNullsy } from '~/_shared/utils/typeGuards';
import { useGetPlaceFromActivePlace } from '~/sidebar/sidebarApps/mapTools/placesTool/hooks/useGetPlaceFromActivePlace';
import { usePlacesSearchResults } from '~/sidebar/sidebarApps/mapTools/placesTool/hooks/usePlacesSearchResults';
import {
  useActivePlaceSelector, usePlacesHoveredPlaceInListSelector,
} from '~/store/frontendState/places/places.selectors';
import { useMapSettingsPlacesSearchesSelector } from '~/store/mapSettings/places/mapSettingsPlaces.selectors';
import { useMapContext } from '../mapContext';
import { ActivePlaceIndicatorOverlay } from '../mapOverlays/activeMarkerIndicator/activePlaceIndicator.container.overlay';
import { HoveredMarkerIndicator } from '../mapOverlays/hoveredMarkerIndicator/hoveredMarkerIndicator';
import { MapPlacesManager } from './mapPlacesManager';
import { PlacesSearchHoverOverlayContainer } from './placesSearchHoverOverlay.container';
import { PlacesSearchInstance } from './placesSearchInstance';

export const PlacesOverlay = () => {
  const activePlace = useActivePlaceSelector();
  const placesSearches = useMapSettingsPlacesSearchesSelector();
  const placesSearchResults = usePlacesSearchResults();
  const hoveredPlaceInListId = usePlacesHoveredPlaceInListSelector();
  const { place: hoveredPlaceInList } = useGetPlaceFromActivePlace(hoveredPlaceInListId);
  const { webglLayers, map } = useMapContext();
  const cleanMapRequired = useRequiresCleanMap();

  const manager = useMemo(() => new MapPlacesManager(webglLayers), [webglLayers]);

  if (cleanMapRequired) {
    return null;
  }

  return (
    <>
      {placesSearches.map((search => {
        const searchResults = placesSearchResults.get(search.id);

        if (!isResourcePartiallyLoaded(searchResults)) {
          return null;
        }

        return (
          <PlacesSearchInstance
            manager={manager}
            key={search.id}
            item={search}
            results={searchResults.value}
          />
        );
      })).filter(notNullsy)}
      {activePlace && (
        <ActivePlaceIndicatorOverlay
          map={map}
          activePlace={activePlace}
        />
      )}
      <PlacesSearchHoverOverlayContainer />
      {hoveredPlaceInList && (
        <HoveredMarkerIndicator
          map={map}
          position={hoveredPlaceInList.location}
        />
      )}
    </>
  );
};
